import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const ShipmentTrackingRegular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    version='1.1'
    id='Icons'
    x='0px'
    y='0px'
    viewBox='84.45 76.78 572.03 259.79'
    {...props}
  >
    <switch>
      <g>
        <path
          style={{ fill: 'white' }}
          d='M252.58,298.98h-15.6c-0.5,0-5.04-0.03-10.59-1.15c-8.54-1.72-15.18-5.09-19.74-10.02 			c-4.78-5.16-7.01-11.75-6.45-19.04c0.51-6.61,6.25-11.55,12.88-11.04c6.61,0.51,11.55,6.28,11.04,12.88 			c-0.04,0.56,0.03,0.77,0.03,0.77c0.9,1.64,7.85,3.6,12.82,3.6h15.6c6.63,0,12,5.37,12,12S259.21,298.98,252.58,298.98z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M534.71,298.98H327.75c-6.63,0-12-5.37-12-12s5.37-12,12-12h206.96c6.63,0,12,5.37,12,12 			S541.34,298.98,534.71,298.98z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M644.47,298.98h-34.59c-6.63,0-12-5.37-12-12s5.37-12,12-12h22.59v-54.87l-59.61-28.02 			c-1-0.47-1.93-1.08-2.77-1.8l-103.03-89.51H228.13c-6.63,0-12-5.37-12-12s5.37-12,12-12h243.42c2.89,0,5.69,1.04,7.87,2.94 			l105.16,91.35l65,30.55c4.21,1.98,6.9,6.21,6.9,10.86v74.49C656.47,293.61,651.1,298.98,644.47,298.98z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M440.96,194.25c-3.17,0-6.21-1.25-8.45-3.48c-2.27-2.25-3.55-5.32-3.55-8.52v-52.23c0-6.63,5.37-12,12-12 			s12,5.37,12,12v40.14l124.92-0.92c0.03,0,0.06,0,0.09,0c6.59,0,11.95,5.31,12,11.91c0.05,6.63-5.28,12.04-11.91,12.09 			l-137.01,1.01C441.02,194.25,440.99,194.25,440.96,194.25z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M572.3,336.57c-27.34,0-49.59-22.24-49.59-49.59c0-27.34,22.24-49.59,49.59-49.59 			c27.34,0,49.59,22.24,49.59,49.59C621.88,314.32,599.64,336.57,572.3,336.57z M572.3,261.4c-14.11,0-25.59,11.48-25.59,25.59 			s11.48,25.59,25.59,25.59s25.59-11.48,25.59-25.59S586.4,261.4,572.3,261.4z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M290.17,336.57c-27.34,0-49.59-22.24-49.59-49.59c0-27.34,22.24-49.59,49.59-49.59s49.59,22.24,49.59,49.59 			C339.75,314.32,317.51,336.57,290.17,336.57z M290.17,261.4c-14.11,0-25.59,11.48-25.59,25.59s11.48,25.59,25.59,25.59 			s25.59-11.48,25.59-25.59S304.27,261.4,290.17,261.4z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M290.17,194.25H96.45c-6.63,0-12-5.37-12-12s5.37-12,12-12h193.72c6.63,0,12,5.37,12,12 			S296.79,194.25,290.17,194.25z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M246.75,147.69h-119.1c-6.63,0-12-5.37-12-12s5.37-12,12-12h119.1c6.63,0,12,5.37,12,12 			S253.38,147.69,246.75,147.69z'
        ></path>
        <path
          style={{ fill: 'white' }}
          d='M246.75,240.8h-119.1c-6.63,0-12-5.37-12-12s5.37-12,12-12h119.1c6.63,0,12,5.37,12,12 			S253.38,240.8,246.75,240.8z'
        ></path>
      </g>
    </switch>
  </svg>
)

export { ShipmentTrackingRegular }
